import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import _ from 'underscore';

import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import TaskStatusIcon from 'processes/status/TaskStatusIcon';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';
import {BLUE_LIGHTEST, GREEN_LIGHTEST, ORANGE_LIGHTEST, RED_LIGHTEST, GRAY_LIGHTER} from 'ui-library/Colors';

interface ProcessTaskStatusDisplayProps {
  statusType: ProcessTaskStatusType;
  displayName: string;
  showTerminalStatusTooltip: boolean;
}

export function InlineProcessTaskStatusDisplay(props: {
  statusType: ProcessTaskStatusType;
  displayName: string;
}): JSX.Element {
  return (
    <span className={css(inlineTaskDisplayStyles[props.statusType])}>
      <TaskStatusIcon type={props.statusType} />
      <strong>{props.displayName}</strong>
    </span>
  );
}

export default function ProcessTaskStatusDisplay(props: ProcessTaskStatusDisplayProps): JSX.Element {
  return (
    <TooltipWrapper
      tooltipTitle={
        props.showTerminalStatusTooltip ? `Status can't be changed from ${props.displayName}` : null
      }
    >
      <span className={css(styles.taskStatusDisplayStyle)}>
        <TaskStatusIcon type={props.statusType} /> {props.displayName}
      </span>
    </TooltipWrapper>
  );
}

const STATUS_TYPE_TO_BACKGROUND_COLOR: Record<ProcessTaskStatusType, string> = {
  [ProcessTaskStatusType.PENDING]: GRAY_LIGHTER,
  [ProcessTaskStatusType.IN_PROGRESS]: BLUE_LIGHTEST,
  [ProcessTaskStatusType.FAILED]: RED_LIGHTEST,
  [ProcessTaskStatusType.CANCELLED]: RED_LIGHTEST,
  [ProcessTaskStatusType.INVALID]: ORANGE_LIGHTEST,
  [ProcessTaskStatusType.SKIPPED]: ORANGE_LIGHTEST,
  [ProcessTaskStatusType.COMPLETED]: GREEN_LIGHTEST,
};

const inlineTaskDisplayStyles = StyleSheet.create(
  _.mapObject(STATUS_TYPE_TO_BACKGROUND_COLOR, (color) => ({
    display: 'flex' as 'flex',
    flexDirection: 'row' as 'row',
    alignItems: 'center' as 'center',
    paddingRight: '2px',
    borderRadius: '2px',
    backgroundColor: color,
  }))
);

export const styles = StyleSheet.create({
  taskStatusDisplayStyle: {
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
  },
});
